import React from 'react';
import c from 'classnames';

import { CheckmarkOutline } from '@lyearn/icons';

import Checkbox from '../../../Checkbox';
import { RenderSelectedIndicatorParams } from './types';

export const renderSelectedIndicator = (params: RenderSelectedIndicatorParams) => {
  const { config, multiple, state } = params;

  if (multiple) {
    return (
      <Checkbox
        checked={state.selected}
        className={c('bg-bg-primary rounded-none', config?.Checkbox)}
      />
    );
  }

  if (state.selected) {
    return (
      <CheckmarkOutline className={c('shrink-0', config?.Icon)} fillColorToken="icon-active" />
    );
  }

  return null;
};
